import { User } from '../types';

/**
 * Check if a user has a specific role
 */
export const hasRole = (user: User | null, role: string): boolean => {
  if (!user) return false;
  
  // Check new roles array first
  if (user.user_roles && user.user_roles.length > 0) {
    return user.user_roles.includes(role);
  }
  
  // Fallback to old user_type field for backward compatibility
  return user.user_type === role;
};

/**
 * Check if a user is an admin (has admin role)
 */
export const isAdmin = (user: User | null): boolean => {
  return hasRole(user, 'admin');
};

/**
 * Check if a user is an engineer (has engineer role)
 */
export const isEngineer = (user: User | null): boolean => {
  return hasRole(user, 'engineer');
};

/**
 * Get all roles for a user
 */
export const getUserRoles = (user: User | null): string[] => {
  if (!user) return [];
  
  // Return new roles array if available
  if (user.user_roles && user.user_roles.length > 0) {
    return user.user_roles;
  }
  
  // Fallback to old user_type field
  return user.user_type ? [user.user_type] : [];
};